module.exports = __webpack_public_path__ + "img/it.e8aacaa3.png";